import React, { useState } from "react";
import { Modal, Form, Button, Typography, message } from "antd";
import IconConfirm from '../../../assets/images/confirm.png';
import Service from "./../../../utils/apiOpen";

function XacNhanNgung(props) {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const Suspension = async () => {
    setLoading(true);
    const dataForm = {
      "uid": props?.detail?.uid || undefined,
      "status": 'cho_kiem_duyet' || undefined,
      "reasonForSuspension": props?.detail?.reasonForSuspension || undefined
    }
    await Service.openApiCall("PATCH", `/v1/affiliate/portal/product`, dataForm)
      .then((res) => {
        setLoading(false);
        let data = res?.data;
        if (data.success) {
          props.MessageSucces('Ngừng Hoạt Động Sản Phẩm Thành Công.');
          props.getList();
          props.handleCancel();
        }
      })
      .catch((err) => {
        setLoading(false);
        if (err?.response) {
          message.error(err?.response?.data?.error?.statusCode + '|' + err?.response?.data?.message);
        }
      });
  };

  return (
    <Modal open={true} onOk={''} onCancel={props.handleCancel} closable={true} footer={null} centered width={380}>
      <div style={{ display: 'flex', justifyContent: 'center', textAlign: 'center', padding: '16px' }}>
        <img src={IconConfirm} alt="" style={{ width: '60px' }} />
      </div>
      <div style={{ display: 'flex', justifyContent: 'center', textAlign: 'center', padding: '16px' }}>
        <Typography.Text style={{ fontSize: 15, fontWeight: 700, color: '#4b4b4b' }}>
          Bạn có chắc chắn ngừng bán sản <br />phẩm này?
        </Typography.Text>
      </div>
      <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 16 }}>
        <Button
          onClick={() => props.handleCancel()}
          size='large'
          style={{ flex: 1, backgroundColor: '#F0F2F5', border: '1px solid #f0f2f5', color: '#4b4b4b', fontWeight: 500, marginRight: 8 }}>
          Thoát
        </Button>
        <Button
          loading={loading}
          onClick={() => Suspension()}
          type="primary"
          size='large'
          style={{ flex: 1, backgroundColor: '#0B7CE4', border: 'none', color: '#fff', fontWeight: 500, marginLeft: 8 }}>
          Tiếp tục
        </Button>
      </div>
    </Modal>
  );
}

export default XacNhanNgung;
